// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dialog_DLuUy { 
  --size-dialogMaxHeight : none;
  --size-dialogMaxWidth : none;
}

.dialogBody_be5rr {
  overflow-y: hidden;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/ui-video/lib/processors/VideoStreamRenderer.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":[".dialog { \n  --size-dialogMaxHeight : none;\n  --size-dialogMaxWidth : none;\n}\n\n.dialogBody {\n  overflow-y: hidden;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dialog": `dialog_DLuUy`,
	"dialogBody": `dialogBody_be5rr`
};
export default ___CSS_LOADER_EXPORT___;
